export default new Vue()
